import { FC } from "react";

import { Contact, Marker } from "shared/assets/icons";
import { SideMenu } from "shared/components";
import { ISideMenuItem } from "shared/components/SideMenu/types";
import { copy } from "shared/assets";

import { BAND_PATHS } from "Bands/router";
import { useBandContext } from "Bands/contexts";
import { useMemo } from "react";
import { useBandRoute } from "Bands/utils";
import { buildUrl } from "shared/utils";

const {
  bandAssets: { sidemenu, bandSettingsIds, navLabel },
} = copy;

export const BandAssetsSideMenu: FC = () => {
  const { bandId } = useBandContext();
  const { getPath } = useBandRoute();

  const items: ISideMenuItem[] = useMemo(
    () =>
      bandId
        ? [
            {
              id: bandSettingsIds.contacts,
              title: sidemenu.contacts,
              path: getPath(BAND_PATHS.BAND_ASSETS_CONTACTS),
              matchPaths: [getPath(BAND_PATHS.BAND_ASSETS_CONTACTS)],
              icon: Contact,
            },
            {
              id: bandSettingsIds.places,
              title: sidemenu.places,
              path: getPath(BAND_PATHS.BAND_ASSETS_PLACES),
              matchPaths: [getPath(BAND_PATHS.BAND_ASSETS_PLACES)],
              icon: Marker,
            },
          ]
        : [],
    [bandId, getPath]
  );

  if (!bandId) return null;

  return (
    <SideMenu
      title={navLabel}
      titleUrl={buildUrl(BAND_PATHS.BAND_ASSETS, { bandId })}
      items={items}
    />
  );
};
